import useStore from '../../../store'
import NeedingAttentionItem from './NeedingAttentionItem'
import Alert from '../../ui/alert'
import { colors } from '../../../utilities/colors'

export default function UnitsNeedingAttention() {
  const dealer = useStore((state) => state.dealer)

  const items = [
    {
      needsAttentionUnitCount: dealer.attributes['untouched-unit-count'],
      testId: 'untouched',
      text: 'Untouched 60+ Days:',
    },
    {
      needsAttentionUnitCount: dealer.attributes['sold-unit-count'],
      testId: 'sold',
      text: 'Sold Units:',
    },
    {
      needsAttentionUnitCount: dealer.attributes['repo-unit-count'],
      testId: 'repos',
      text: 'Repo Units:',
    },
    {
      needsAttentionUnitCount: dealer.attributes['past-due-unit-count'],
      testId: 'past-due',
      text: 'Past Due Units:',
    },
  ]

  return(
    <div className='pb-2'>
      <Alert
        title="Units Needing Attention"
        bgColor={colors.fpxRed}
      >
        {items.map((item, index) => (
          <NeedingAttentionItem
            key={index}
            needsAttentionUnitCount={item.needsAttentionUnitCount}
            testId={item.testId}
            text={item.text}
          />
        ))}
      </Alert>
    </div>
  )
}